import React from 'react';
import styles from './About.module.css';

const About: React.FC = () => {
  return (
    <section className="container mt-5">
      <h2>Om Perler med Vilje</h2>
      <div className="row mt-4">
              <div className="lead col-md-6">
        <p>
            Jeg het egentlig bare Ella, men da jeg var sju fikk jeg et navn til.
            </p>
            <p>
            Jeg har vokst opp i skogen, i Maridalen, helt nord i Oslo.
            Fra jeg var liten har jeg gjort det meste med vilje. Nå heter jeg Ella Vilje, og jeg elsker å perle!
            </p>
            <p>
           Men jeg vil også gjerne lære meg hvordan en bedrift fungerer, og - om jeg kan - kanskje hjelpe noen andre på veien. For en tid siden bygde pappaen min og jeg en bod, hvor jeg solgte perlesmykkene mine. Det var gøy, men nå vil jeg gjerne utvide boden, så derfor har vi laget en nettbutikk hvor du kan bestille smykker direkte, også sender jeg deg dem i posten.
            </p>
            <p>
            Tjuefem prosent av alt du kjøper går direkte til Redd barna, og resten går til å utvikle Perler med Vilje. Og kanskje en is, da.
            </p>
            <p>
            Jeg håper du liker perlene!
                  </p>
                  <p>
                      Lurer du på noe, ta gjerne kontakt med meg: <a href="mailto:perlermedvilje@gmail.com" className={styles.emailLink}>perlermedvilje@gmail.com</a>
                  </p>

        </div>
        <div className="col-md-6">
          <img 
            src="/ella-portrett.png" 
            alt="Ella Vilje med perler" 
            className="img-fluid rounded shadow" 
            onError={(e) => {
              e.currentTarget.src = "https://picsum.photos/id/241/500/300"; // Fallback image
              e.currentTarget.onerror = null;
            }} 
          />
        </div>
      </div>
    </section>
  );
};

export default About;